import Icon from '../components/Icon.vue'

Icon.register({"lock":{"width":1152,"height":1792,"paths":[{"d":"M320 768h512v-192q0-106-75-181t-181-75-181 75-75 181v192zM1152 864v576q0 40-28 68t-68 28h-960q-40 0-68-28t-28-68v-576q0-40 28-68t68-28h32v-192q0-184 132-316t316-132 316 132 132 316v192h32q40 0 68 28t28 68z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/lock.js
// module id = 1649
// module chunks = 0